import Axios from "axios";
import { Cookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import { API_REFRESH_TOKEN } from "../config/api";

// The env switch used to build every request URL. Exported so callers that
// need an absolute URL (e.g. a paginator path handed to GridTable) can reuse
// it instead of repeating the ternary.
export const getBaseUrl = () =>
  process.env.REACT_APP_APP_ENV === "staging"
    ? process.env.REACT_APP_STAGING_BASE_URL
    : process.env.REACT_APP_APP_ENV === "dev"
      ? process.env.REACT_APP_DEV_BASE_URL
      : process.env.REACT_APP_PRODUCTION_BASE_URL;

export const Client = async (params) => {
  const cookies = new Cookies();
  const token = cookies.get("accessToken");
  const {
    path,
    type,
    method,
    data,
    queryParams,
    noRefreshToken,
    contentType = "application/json",
    responseType = "json",
  } = params;

  const baseURL = getBaseUrl();

  const headers = {
    ...(token && {
      Authorization: `Bearer ${token}`,
    }),
    "Content-Type": contentType,
    "ngrok-skip-browser-warning": "true",
    Accept: "application/json",
  };

  let url = type === "full-path" ? path : `${baseURL}api/v1/${path}`;

  const axiosConfig = {
    method: method,
    url: url,
    timeout: 100000,
    headers: headers,
    params: queryParams,
    responseType: responseType,
  };

  if (method?.toUpperCase() !== "GET") {
    axiosConfig.data =
      contentType === "multipart/form-data" ? data : JSON.stringify(data);
  }

  try {
    const response = await Axios(axiosConfig);

    if (!noRefreshToken && token) {
      const decoded = jwtDecode(token);
      const newDate = new Date(0);
      const dateOfExp = new Date(newDate.setUTCSeconds(decoded.exp)).getTime();
      newDate.setUTCSeconds(decoded.exp);

      const current = new Date().getTime();
      const getMins = parseInt((dateOfExp - current) / (1000 * 60));

      if (getMins < 19) {
        const {
          data: {
            data: { access_token },
          },
        } = await Axios({
          url: `${baseURL}api/v1/${API_REFRESH_TOKEN}`,
          timeout: 20000,
          headers: headers,

          responseType: "json",

          method: "POST",
        });

        if (access_token) {
          const nextDate = new Date().setMinutes(new Date().getMinutes() + 20);
          cookies.set("accessToken", access_token, {
            expires: new Date(nextDate),
          });
        }
      }
    }

    return response;
  } catch (error) {
    console.error("Error in Axios request:", error);
    if (
      (error?.response?.status === 401 || error?.response?.status === 403) &&
      cookies.get("accessToken")
    ) {
      // localStorage.removeItem("accessToken");
      // window.location.href = "/login";
    } else if (!cookies.get("accessToken")) {
      window.location.href = "/login";
    } else {
      throw error;
    }
  }
};
